import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { authApi, meApi } from './api';
import first from 'lodash/first';
import get from 'lodash/get';
import pick from 'lodash/pick';

const initialState = {
  user: null,
  company: null,
  // hack login
  token: '',
  refreshToken: '',
  // hack login
  isAuthorized: false,
  status: '',
  error: null
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: () => initialState,
    verifiedAuth: (state, action) => {
      state.isAuthorized = true;
      state.token = action.payload.token;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authApi.endpoints.login.matchPending,
      (state, action) => {
        state.status = action.meta.requestStatus;
      }
    );
    builder.addMatcher(
      authApi.endpoints.login.matchFulfilled,
      (state, action) => {
        state.status = action.meta.requestStatus;
        state.token = action.payload.token;
        state.refreshToken = action.payload.refreshToken;
        state.isAuthorized = true;
      }
    );
    builder.addMatcher(
      authApi.endpoints.login.matchRejected,
      (state, action) => {
        state.status = action.meta.requestStatus;
        state.error = action.payload?.data as any;
      }
    );
    builder.addMatcher(meApi.endpoints.me.matchPending, (state, action) => {
      state.status = action.meta.requestStatus;
    });
    builder.addMatcher(meApi.endpoints.me.matchFulfilled, (state, action) => {
      state.status = action.meta.requestStatus;
      state.company = get(
        first(action.payload?.data.companyMaps ?? []),
        'company'
      ) as any;
      state.user = pick(action.payload?.data, [
        'email',
        'id',
        'locale',
        'roleId'
      ]) as any;

      // state.token = action.payload.token;
      // state.refreshToken = action.payload.refreshToken;
    });
    builder.addMatcher(meApi.endpoints.me.matchRejected, (state, action) => {
      state.status = action.meta.requestStatus;
      state.error = action.payload?.data as any;
    });
  }
});

export const { logout, verifiedAuth } = slice.actions;
export default slice.reducer;

export const authSelector = createSelector(
  (state: RootState) => state,
  (state) => state.auth
);
